var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Icon } from "sb-resp-ui";
import { eBranches } from "sb-helpers";
import { EventInfo, EventInfoSingleItemOrMobileView, EventInfoMultipleItems, SuperBannerButtons } from "../../components";
import { returnValueHelper } from "../../../../helpers";
let SuperBannerEvent = class SuperBannerEvent extends React.PureComponent {
    render() {
        const { eventInfo, isSingleItemOrMobileView } = this.props;
        const outrightMdf = returnValueHelper(eventInfo.pickedEvent.IsOutright, "outright", "");
        const boundOpenGameRace = this.props.openRaceGame.bind(eventInfo.pickedEvent.Link);
        return (React.createElement("div", { className: "rj-superbanner__event-container", "data-uat": "superbanner-event-container" },
            React.createElement(EventInfo, { link: eventInfo.pickedEvent.Link, modifier: outrightMdf, handler: returnValueHelper((eventInfo.event.sportID === eBranches.HorseRacing.toString() || eventInfo.event.sportID === eBranches.GreyHoundsRacing.toString()), boundOpenGameRace, eventInfo.boundOpenGameTranspiler) },
                returnValueHelper(isSingleItemOrMobileView, React.createElement(EventInfoSingleItemOrMobileView, Object.assign({}, eventInfo)), React.createElement(EventInfoMultipleItems, Object.assign({}, eventInfo))),
                eventInfo.pickedEvent.IsOutright && React.createElement(Icon, { i: `i-24 i-o-sport-${eventInfo.event.sportID} rj-superbanner__sport-icon` }) || ""),
            React.createElement(SuperBannerButtons, Object.assign({}, this.props, { pickedEvent: eventInfo.pickedEvent }))));
    }
};
SuperBannerEvent = __decorate([
    observer
], SuperBannerEvent);
export { SuperBannerEvent };
//# sourceMappingURL=SuperBannerEvent.js.map